<template>

<div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

            <v-flex xs12 sm12>

                <v-toolbar size="120px" dark color="info">

                    <v-toolbar-title class="baslikfont">{{this.$t('Debtor-Creditor-List')}}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="this.$t('Search')" append-icon="search">

                    </v-text-field>

                    <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}

</v-btn>

                    <v-menu offset-y>

                        <v-btn slot="activator" dark icon>

                            <v-icon>more_vert</v-icon>

                        </v-btn>

                        <v-list>

                            <v-list-tile @click="getListHtml()">

                                <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                            </v-list-tile>

                            <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">

                                <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                            </v-list-tile>

                        </v-list>

                    </v-menu>

                </v-toolbar>

            </v-flex>

            <v-flex xs12 sm12 md12>

                <v-layout row wrap>

                    <v-flex xs12 sm6 md6 pl-2 pt-2 pb-2>

                        <v-card color="#1E88E5" class="white--text">

                            <v-layout>

                                <v-flex xs2 sm2 md2>

                                    <v-layout align-center="" justify-center="" fill-height="">

                                        <v-icon color="white" large="">add_comment</v-icon>

                                    </v-layout>

                                </v-flex>

                                <v-flex xs12 sm10 md10>

                                    <v-card-title primary-title="">

                                        <v-flex xs12 sm12 md12>

                                            <v-layout>

                                                <v-flex xs12 sm3 md12>

                                                    <v-list-tile-title>

                                                        <span class="subheading font-weight-">

                                                           {{ totalDueDebt | moneyformat }}{{getparabirimi()}}

                                                        </span>

                                                    </v-list-tile-title>

                                                </v-flex>

                                            </v-layout>

                                        </v-flex>

                                    </v-card-title>

                                </v-flex>

                            </v-layout>

                            <v-divider light></v-divider>

                            <v-card-actions class="pa-3">

                                <span class="subheading font-weight-bold" v-if="Borc.Tip == 2"> {{ $t('Due-General-Total') }} </span>

                                <span class="subheading font-weight-bold" v-else>  {{ $t('Debt-General-Total') }} </span>

                                <v-spacer></v-spacer>

                            </v-card-actions>

                        </v-card>

                    </v-flex>

                    <v-flex xs12 sm6 md6 pl-2 pt-2 pb-2>

                        <v-card color="#1E88E5" class="white--text">

                            <v-layout>

                                <v-flex xs2 sm2 md2>

                                    <v-layout align-center="" justify-center="" fill-height="">

                                        <v-icon color="white" large="">cached</v-icon>

                                    </v-layout>

                                </v-flex>

                                <v-flex xs12 sm10 md10>

                                    <v-card-title primary-title="">

                                        <v-flex xs12 sm12 md12>

                                            <v-layout>

                                                <v-flex xs12 sm3 md12>

                                                    <v-list-tile-title>

                                                        <span class="subheading font-weight-">

                                                            {{totalGrandDebt | moneyformat }}{{getparabirimi()}}

                                                        </span>

                                                    </v-list-tile-title>

                                                </v-flex>

                                            </v-layout>

                                        </v-flex>

                                    </v-card-title>

                                </v-flex>

                            </v-layout>

                            <v-divider light></v-divider>

                            <v-card-actions class="pa-3">

                                <span class="subheading font-weight-bold" v-if="Borc.Tip == 2"> {{ $t('Total-Term-Due') }} </span>

                                <span class="subheading font-weight-bold" v-else> {{ $t('Total-Due-Debts') }} </span>

                                <v-spacer></v-spacer>

                            </v-card-actions>

                        </v-card>

                    </v-flex>

                </v-layout>

            </v-flex>

            <v-flex pl-2 xs12 pt-2 sm12 md12>

                <v-card flat>

                    <v-layout row wrap>

                        <v-flex pt-1 pl-1 xs12 sm6 md2>

                            <v-form ref="formtarih" v-model="valid" lazy-validation>

                                <tarihcomp :etiket="this.$t('Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>

                            </v-form>

                        </v-flex>

                        <v-flex pt-1>

                            <v-layout>

                                <div v-if="load1">

                                    <v-btn color="info" @click="getList()" fab small="" dark>

                                        <v-icon>search</v-icon>

                                    </v-btn>

                                </div>

                                <v-layout v-if="!load1" row wrap fill-height="" align-center="">

                                    <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                                </v-layout>

                                <v-badge v-if="load1" color="white" :overlap="true">

                                    <template v-slot:badge>

                                        <v-icon v-if="filtrevarmi" large color="green">

                                            check_circle_outline </v-icon>

                                    </template>

                                    <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()" color="info" fab dark>

                                        <v-icon>filter_list</v-icon>

                                    </v-btn>

                                    <v-tooltip bottom="" :activator="el" v-model="tooltip">

                                        <span>{{$t('Add-Search-Filter')}}</span>

                                    </v-tooltip>

                                </v-badge>

                            </v-layout>

                        </v-flex>

                        <v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>{{ $t('Send-Mail') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              :label="$t('Recipient-Email')"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              :label="$t('Agency-Name')"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              :label="$t('Document-Type')"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              :label="$t('Agent-Full-Name')"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              :label="$t('Message')"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">{{ $t('Cancel') }}</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>{{ $t('Send') }}

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>

                        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="800px">

                            <v-card color="grey lighten-5">

                                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

                                <v-divider></v-divider>

                                <v-card-text>

                                    <v-layout row="" wrap="">

                                        <v-flex xs12 sm6 md6>

                                            <cariaracomp v-bind:etiket="$t('Select-Starting-Current')" v-bind:value="Borc.BaslangicCariKod" :loading="loading1" v-model="Borc.BaslangicCariKod"></cariaracomp>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <cariaracomp v-bind:etiket="$t('Select-Ending-Current')" v-bind:value="Borc.BitisCariKod" :loading="loading2" v-model="Borc.BitisCariKod"></cariaracomp>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <v-select :items="masrafmerkezi" hide-details="" :label="$t('Expense-Center-v2')" v-model="Borc.Masraf" item-text="Title" clearable item-value="Code" max-height="400">

                                            </v-select>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <!-- <v-select :items="Referans" hide-details="" :label="$t('Reference')" v-model="Borc.Referans" item-text="Title" item-value="Kod" max-height="400"></v-select> -->

                                            <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="Borc.Referans" >

                              </referansmerkezicomp>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <v-autocomplete hide-details="" clearable :items="hesapgurubu" :label="$t('Account-Group-Requested')" multiple item-text="Title" v-model="Borc.Gruplar" item-value="Kod">

                                                <template slot="selection" slot-scope="{ item, index }">

                                                    <div v-if="index === 0">

                                                        <span>{{ item.Title }}</span>

                                                    </div>

                                                    <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{

                                                                Borc.Gruplar.length -

                                                                1

                                                                }} {{ $t('Other') }})</span>

                                                </template>

                                            </v-autocomplete>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <v-autocomplete hide-details="" clearable :items="hesapgurubu" :label="$t('Account-Group-Not-Requested')" multiple item-text="Title" v-model="Borc.NoGruplar" item-value="Kod">

                                                <template slot="selection" slot-scope="{ item, index }">

                                                    <div v-if="index === 0">

                                                        <span>{{ item.Title }}</span>

                                                    </div>

                                                    <span v-if="index === 1" class="grey--text caption">&nbsp;(+{{

                                                                Borc.NoGruplar.length -

                                                                1

                                                                }} {{ $t('Other') }})</span>

                                                </template>

                                            </v-autocomplete>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <cariaracomp v-bind:etiket="$t('Main-Account')" v-bind:value="Borc.AnaHesap" :loading="loading" v-model="Borc.AnaHesap"></cariaracomp>

                                        </v-flex>

                                        <v-flex xs12 sm12 pt-4 md12>

                                            <v-layout row wrap class=" project overdue">

                                                <v-toolbar flat="" size="120px" dark color="grey lighten-5">

                                                    <v-toolbar-title>

                                                        <span class="headline black--text font-weight-">

                                                            {{ $t('Options-v2') }}

                                                        </span>

                                                    </v-toolbar-title>

                                                    <v-spacer></v-spacer>

                                                </v-toolbar>

                                            </v-layout>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <v-layout row wrap>

                                                <v-flex xs12 sm6 md6>

                                                    <v-layout row wrap>

                                                        <v-flex xs12 sm12 md12>

                                                            <v-radio-group v-model="Borc.Sira" column>

                                                                <v-radio :label="$t('Code-Order')" value='0'></v-radio>

                                                                <v-radio :label="$t('Name-Order')" value='1'></v-radio>

                                                                <v-radio :label="$t('Account-Group-Order')" value='2'></v-radio>

                                                            </v-radio-group>

                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12>

                                                            <v-radio-group v-model="Borc.ProgramDetay" label="" column>

                                                                <v-radio :label="$t('All-v2')" value='0'> </v-radio>

                                                                <v-radio :label="$t('Ticket')" value='1'></v-radio>

                                                                <v-radio :label="$t('Free')" value='2'></v-radio>

                                                                <v-radio label="Coper " value='3'></v-radio>

                                                            </v-radio-group>

                                                        </v-flex>

                                                    </v-layout>

                                                </v-flex>

                                                <v-flex xs12 sm6 md6>

                                                    <v-layout row wrap>

                                                        <v-flex xs12 sm12 md12>

                                                            <v-radio-group v-model="Borc.Tip" label="" column>

                                                                <v-radio :label="$t('All-v2')" value='0'> </v-radio>

                                                                <v-radio :label="$t('Debtor-List')" value='1'></v-radio>

                                                                <v-radio :label="$t('Debtee-List')" value='2'></v-radio>

                                                            </v-radio-group>

                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12>

                                                            <v-radio-group v-model="Borc.ProgramTip" label="" column>

                                                                <v-radio :label="$t('All-v2')" value='0'> </v-radio>

                                                                <v-radio :label="$t('Only') +'Coper'" value='1'></v-radio>

                                                                <v-radio :label="'Coper ' + $t('Excluding')" value='2'></v-radio>

                                                            </v-radio-group>

                                                        </v-flex>

                                                    </v-layout>

                                                </v-flex>

                                            </v-layout>

                                        </v-flex>

                                        <v-flex xs12 sm6 md6>

                                            <v-layout row wrap>

                                                <v-flex xs12 sm12 md12>

                                                    <v-checkbox v-model="Borc.VadeCheck" :label="$t('Include-Advanced-Future-Payments-Collections')" hide-details="">

                                                    </v-checkbox>

                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-checkbox v-model="Borc.PosTutarDahilEtme" :label="$t('Dont-Include-POS-Amounts-List')" hide-details="">

                                                    </v-checkbox>

                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-checkbox v-model="Borc.TsNofat" :label="$t('Do-Not-Show-Records-without-Coper-Invoice')" hide-details=""></v-checkbox>

                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-checkbox v-model="Borc.BirCheck" :label="$t('Show-those-under-one-TL')" hide-details="">

                                                    </v-checkbox>

                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-checkbox v-model="Borc.TelVadeCheck" :label="$t('Show-Tel-and-Due-Date-Details')" hide-details=""></v-checkbox>

                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                                                </v-flex>

                                            </v-layout>

                                        </v-flex>

                                    </v-layout>

                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>

                                    <v-spacer></v-spacer>

                                    <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                                    <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

                                </v-card-actions>

                            </v-card>

                        </v-dialog>

                    </v-layout>

                </v-card>

            </v-flex>

            <v-flex pl-2 xs12 pt-2 sm12 md12>

                <v-card flat>

                    <v-layout row wrap>

                        <v-flex pt-1 xs12 sm12 md12>

                            <v-card flat>

                                <!-- Ortak modern rapor tablosu.
                                 Eski API, filtre, mail ve üç nokta menüsündeki export işlemleri aynen korunmuştur. -->
                            <div class="borclu-report-table">
                                <ReportTable
                                    :headers="headers"
                                    :items="filteredBorcluItems"
                                    storage-key="borclulistesi_columns"
                                    :loading="progress"
                                    :has-searched="items && items.length > 0"
                                    :show-search="true"
                                    :search-label="$t('Search')"
                                    :show-frontend-export="true"
                                    :export-title="$t('Debtor-Creditor-List')"
                                    :export-meta-items="borcluExportMetaItems"
                                    :export-summary-cards="borcluExportSummaryCards" 
                                    :rows-per-page-items="[50, 100, 250, 500, 1000]"
                                >
                                    <template slot="cell" slot-scope="{ item, column, value }">
                                        <div
                                            class="borclu-report-cell"
                                            @click="git(item.Account+'-'+item.Date+'-'+item.Id)"
                                        >
                                            {{ value }}
                                        </div>
                                    </template>
                                </ReportTable>
                            </div>

                            </v-card>

                            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

                                {{ text1 }}

                                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

                            </v-snackbar>

                        </v-flex>

                    </v-layout>

                </v-card>

            </v-flex>

        </v-layout>

    </v-card>

</div>

</template>

<script>

import auth from '../../../api/auth'

import helpers from "@/components/app/customcomp/helpers.js"

import tarihcomp from "@/components/app/customcomp/tarihim"

import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

import cariaracomp from '@/components/app/customcomp/cariaracomp'

import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"

import ReportTable from "@/components/app/customcomp/ReportTable.vue"

export default {

    data() {

        return {

            mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || this.$t('Required-Field'),

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.$t('Enter-Valid-Email')

},

            PB:'TRY',

            sayfayetki: {

                Screen: false,

                Update: false,

                Save: false,

                Delete: false,

                Status: false,

                Message: null,

                islem: 0,

            },

            search: '',

            hesapgurubu: [],
            headers: [{
                    text: this.$t('Current-Account-Code'),
                    value: 'CurrentCode',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    align: 'left',
                    width: '170px'
                },
                {
                    text: this.$t('Title_label'),
                    value: 'CurrentTitle',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    align: 'left',
                    width: '300px'
                },
                {
                    text: this.$t('Telephone'),
                    value: 'Phone',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    align: 'left',
                    width: '170px'
                },
                {
                    text: this.$t('Email_label'),
                    value: 'Email',
                    visible: true,
                    sortable: true,
                    type: 'text',
                    align: 'left',
                    width: '260px'
                },
                {
                    text: this.$t('Total-Debit'),
                    value: 'TotalDebt',
                    align: 'right',
                    visible: true,
                    sortable: true,
                    type: 'money',
                    width: '170px'
                },
                {
                    text: this.$t('Debt-Due'),
                    value: 'TotalDebtDue',
                    align: 'right',
                    visible: true,
                    sortable: true,
                    type: 'money',
                    width: '170px'
                },
                {
                    text: this.$t('Total-Credit'),
                    value: 'TotalCredit',
                    align: 'right',
                    visible: true,
                    sortable: true,
                    type: 'money',
                    width: '170px'
                },
                {
                    text: this.$t('Receivable-Due'),
                    value: 'TotalCreditDue',
                    align: 'right',
                    visible: true,
                    sortable: true,
                    type: 'money',
                    width: '180px'
                }
            ],
            filtrevarmi: false,

            valid: true,

            Borc: {

                SirketKodu: '',

                AnaHesap: null,

                Tarih: '',

                Masraf: '',

                Referans: '',

                TsNofat: false,

                VadeCheck: '',

                PosTutarDahilEtme: false,

                Tip: '0',

                BirCheck: false,

                TelVadeCheck: false,

                Sira: '0',

                ProgramTip: '0',

                ProgramDetay: '0',

                Gruplar: [],

                NoGruplar: []

            },

            tumsirketler: '',

            StartDate: null,

            EndDate: null,

            grandDebt: 0,

            dueDebt: 0,

            totalGrandDebt: 0,

            totalDueDebt: 0,

            date: null,

            menu: false,

            modal: false,

            dateFormatted: '',

            loading1: false,

            loading2: false,

            loading3: false,

            statecari: [],

            statecari2: [],

            items: [],

            search1: '',

            search3: '',

            load: false,

            load1: true,

            butondurum: true,

            loadingana: false,

            searchana: null,

            stateana: [],

            dialogfiltre: false,

            hesapkodu: [],

            Referans: [],

            masrafmerkezi: [],

            anahesap: [],

            renk1: 'info',

            a: '',

            b: '',

            c: '',

            d: '',

            progress: false,

            snackbar: false,

            y: 'top',

            x: 'right',

            mode: '',

            timeout: 6000,

            text1: '',

            tooltip: false,

            el: null,

            dictionary: {

                custom: {

                    tarihsec: {

                        required: () => this.$t('Please-select-a-date')

                    },

                    tarihsec1: {

                        required: () => this.$t('Please-select-a-date')

                    },

                }

            },

        }

    },

    beforeRouteEnter(to, from, next) {

        next(vm => {

            vm.prevRoute = from.path

        })

    },

    beforeMount: beforeMount,

    components: {
        tarihcomp,
        yetkidialog,
        cariaracomp,
        referansmerkezicomp,
        ReportTable
    },

    mounted() {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi

        this.$validator.localize('en', this.dictionary)

        this.el = this.$refs.fab.$el

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

            // this.progress = true

            //this.load1 = false

            this.date = helpers.getDateNow()

            // var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            // var params = {

            //   CompanyCode: credentials.SirketKodu,

            //   StartDate: this.date,

            //   StartCurrentCode: this.Cari1,

            //   EndCurrentCode: this.Cari2

            // }

            // this.$http.post(auth.API_URL + 'api/Report/DebitorList', params, {

            //   headers: {

            //     'Authorization': 'Bearer ' + auth.getAuthHeader()

            //   }

            // }).then((response) => {

            //   this.items = response.body

            //   this.grandDebt = response.body[0].GrandDebt

            //   this.dueDebt = response.body[0].DueDebt

            //   this.progress = false

            //   this.load1 = true

            // }, (response) => {

            //   if (response.status === 0) {

            //     this.text1 = 'Service Unavailable'

            //     this.snackbar = true

            //     this.progress = false

            //     this.load1 = true

            //   } else {

            //     this.text1 = 'Service Unavailable'

            //     this.snackbar = true

            //     this.progress = false

            //     this.load1 = true

            //   }

            // })

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {

                        var url = '#' + this.prevRoute

                        window.open(url, '_self')

                    } else {

                        var url = '#/'

                        window.open(url, '_self')

                    }

                } else {

                }

            });

        }

    },

    computed: {
        borcluExportMetaItems() {
            return [
                {
                    label: this.$t('Date'),
                    value: this.date,
                    type: 'date'
                }
            ]
        },

        borcluExportSummaryCards() {
            var firstTitle = this.Borc.Tip == 2
                ? this.$t('Due-General-Total')
                : this.$t('Debt-General-Total')

            var secondTitle = this.Borc.Tip == 2
                ? this.$t('Total-Term-Due')
                : this.$t('Total-Due-Debts')

            return [
                {
                    title: firstTitle,
                    items: [
                        {
                            label: firstTitle,
                            value: this.totalDueDebt,
                            type: 'money'
                        }
                    ]
                },
                {
                    title: secondTitle,
                    items: [
                        {
                            label: secondTitle,
                            value: this.totalGrandDebt,
                            type: 'money'
                        }
                    ]
                }
            ]
        },

        // Mevcut toolbar araması korunur.
        // ReportTable ekrandaki arama sonucunu gösterir ve yeni exportta da aynı sonucu kullanır.
        filteredBorcluItems() {
            var list = Array.isArray(this.items) ? this.items.slice() : []
            var searchText = (this.search3 || '').toString().trim().toLocaleLowerCase()

            if (!searchText) {
                return list
            }

            return list.filter(function (item) {
                if (!item) {
                    return false
                }

                var values = [
                    item.CurrentCode,
                    item.CurrentTitle,
                    item.Phone,
                    item.Email,
                    item.TotalDebt,
                    item.TotalDebtDue,
                    item.TotalCredit,
                    item.TotalCreditDue
                ]

                return values.some(function (value) {
                    if (value === null || value === undefined) {
                        return false
                    }

                    return value.toString().toLocaleLowerCase().indexOf(searchText) !== -1
                })
            })
        }
    },



    watch: {

    },

    filters: {

        dateformat: function (t) {

            return helpers.dateformat(t);

        },

        moneyformat: function (m) {

            return helpers.moneyformat(m);

        },

        bakiyekontrol: function (m) {

            return helpers.bakiyekontrol(m);

        }

    },

    methods: {

  openMailDialog() {

    const pageDocType = this.$t('Debtor-Creditor-List');

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = pageDocType;

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) {

      return;

    }

    if (!this.date) {

      this.text1 = this.$t('Please-select-a-date');

      this.snackbar = true;

      return;

    }

    const credentialsRaw = window.localStorage.getItem('credentials');

    const credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};

    const companyCode = (this.tumsirketler === true)

      ? '0'

      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    const B = this.Borc || {};

    const inputObj = {

      SirketKodu: companyCode,

      Tarih: this.date || B.Tarih || null,

      Masraf: B.Masraf || null,

      Referans: B.Referans || null,

      TsNofat: !!B.TsNofat,

      VadeCheck: !!B.VadeCheck,

      PosTutarDahilEtme: !!B.PosTutarDahilEtme,

      Tip: (typeof B.Tip !== 'undefined') ? B.Tip : '0',

      BirCheck: !!B.BirCheck,

      TelVadeCheck: !!B.TelVadeCheck,

      Sira: (typeof B.Sira !== 'undefined') ? B.Sira : '0',

      ProgramTip: (typeof B.ProgramTip !== 'undefined') ? B.ProgramTip : '0',

      ProgramDetay: (typeof B.ProgramDetay !== 'undefined') ? B.ProgramDetay : '0',

      Gruplar: Array.isArray(B.Gruplar) ? B.Gruplar : [],

      NoGruplar: Array.isArray(B.NoGruplar) ? B.NoGruplar : [],

      AnaHesap: B.AnaHesap || null,

      BaslangicCariKod: B.BaslangicCariKod || null,

      BitisCariKod: B.BitisCariKod || null

    };

    const fallbackDocType = this.$t('Debtor-Creditor-List');

    const mailObj = {

      To: this.mailPayload.To || "",

      AgencyName: this.mailPayload.AgencyName || "",

      DocType: this.mailPayload.DocType || fallbackDocType,

      AgentFullName: this.mailPayload.AgentFullName || "",

      CustomBody: this.mailPayload.CustomBody || ""

    };

    const payload = { Input: inputObj, Mail: mailObj };

    this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/Report/MailGonderBorcAlacakExcel';

    this.$http.post(

      endpoint,

      payload,

      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }

    ).then(() => {

      this.mailLoading = false;

      this.mailDialog = false;

      this.text1 = this.$t('Mail-Sent');

      this.snackbar = true;

    }, (err) => {

      this.mailLoading = false;

      const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

      const msg = (body && (body.Message || body.message)) || err.statusText || this.$t('Mail-Could-Not-Be-Sent');

      this.text1 = msg;

      this.snackbar = true;

    });

  },



        getparabirimi() {

            return helpers.getparabirimi()

        },

        getList: getList,

        getListHtml: getListHtml,

        getListExcel: getListExcel,

        filtrele: filtrele,

        filtrekayit: filtrekayit,

        filtreiptal: filtreiptal,

        karsidegeral: karsidegeral,

        onChangecheck: onChangecheck

    }

}

function karsidegeral(val) {

    if (val === true) {

        return false

    } else {

        return true

    }

}

function onChangecheck(elem1, elem2) {

    if (this.a === true && elem2 == 'a') {

        this.b = karsidegeral(this.a)

    }

    if (this.b === true && elem2 == 'b') {

        this.a = karsidegeral(this.b)

    }

}

function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {

        CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {

        headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

        }

    }).then((response) => {

        this.hesapgurubu = response.body

    }, (response) => {

        if (response.status === 0) {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

        } else {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

        }

    })

    // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {

    //     headers: {

    //         'Authorization': 'Bearer ' + auth.getAuthHeader()

    //     }

    // }).then((response) => {

    //     this.Referans = response.body

    // }, (response) => {

    //     if (response.status === 0) {

    //         this.text1 = 'Service Unavailable'

    //         this.snackbar = true

    //     } else {

    //         this.text1 = 'Service Unavailable'

    //         this.snackbar = true

    //     }

    // })

    this.Borc.Referans = null

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {

        headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

        }

    }).then((response) => {

        this.masrafmerkezi = response.body

    }, (response) => {

        if (response.status === 0) {

        } else {

        }

    })

    this.Borc.Masraf = null

}

function filtrekayit() {

    this.filtrevarmi = true

    this.getList()

    this.dialogfiltre = false

}

function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.Borc.Masraf = null;

    this.Borc.AnaHesap = null;

    this.Borc.Referans = null;

    this.Borc.TsNofat = null;

    this.Borc.VadeCheck = false

    this.Borc.PosTutarDahilEtme = false

    this.Borc.Tip = '0'

    this.Borc.BirCheck = false

    this.Borc.TelVadeCheck = false

    this.Borc.Sira = '0'

    this.Borc.ProgramTip = '0'

    this.Borc.ProgramDetay = '0'

    this.Borc.Gruplar = []

    this.Borc.NoGruplar = []

}

function getList() {

    if (this.$refs.formtarih.validate()) {

        this.progress = true

        this.grandDebt = 0

        this.dueDebt = 0

        this.totalGrandDebt = 0

        this.totalDueDebt = 0

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

            this.Borc.SirketKodu = '0'

        } else {

            this.Borc.SirketKodu = credentials.SirketKodu

        }

        this.Borc.Tarih = this.date

        var params = this.Borc

        this.load1 = false

        this.$http.post(auth.API_URL + 'api/Report/DebitorList', params, {

            headers: {

                'Authorization': 'Bearer ' + auth.getAuthHeader()

            }

        }).then((response) => {

            this.items = response.body

            if (response.body.length > 0) {

                if(this.Borc.Tip == "2"){

                    this.totalGrandDebt = response.body[0].DueCredit

                    this.totalDueDebt = response.body[0].GrandCredit

                }else{

                    this.totalGrandDebt = response.body[0].DueDebt

                    this.totalDueDebt = response.body[0].GrandDebt

                }





                this.grandDebt = response.body[0].TotalCredit

                this.dueDebt = response.body[0].TotalCreditDue

                response.body[0].TotalCredit = this.grandDebt

                response.body[0].TotalCreditDue = this.dueDebt

            }

            this.progress = false

            this.load1 = true

        }, (response) => {

            if (response.status === 0) {

                this.text1 = this.$t('Service-Unavailable')

                this.snackbar = true

                this.load1 = true

                this.progress = false

            } else {

                this.text1 = this.$t('Service-Unavailable')

                this.snackbar = true

                this.load1 = true

                this.progress = false

            }

        })

    }

}

function getListHtml() {

    this.progress = true

    this.grandDebt = 0

    this.dueDebt = 0

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var lang = localStorage.getItem('lang')

    if (this.tumsirketler === true) {

        this.Borc.SirketKodu = '0'

    } else {

        this.Borc.SirketKodu = credentials.SirketKodu

    }

    this.Borc.Tarih = this.date

    if (this.a === true) {

        this.Borc.Sira = '0'

    } else if (this.b === true) {

        this.Borc.Sira = '1'

    }

    var params = this.Borc

    this.load1 = false

    this.$http

        .post(auth.API_URL + "api/Report/DebitorListHtml", params, {

            headers: {

                Authorization: "Bearer " + auth.getAuthHeader()

            }

        }).then((response) => {

            if (lang=='en')

          {

            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> BORÇLU ALACAKLI LİSTESİ </title>','<title> DEBTOR CREDITOR LIST </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>BORÇLU ALACAKLI LİSTESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>DEBTOR CREDITOR LIST</font>")

             response.bodyText=response.bodyText.toString().replaceAll("Tümü","All");

             response.bodyText=bodyhtml;

          }

            this.progress = false

            this.load1 = true

            var blob = new Blob([response.bodyText], {

                type: 'application/html'

            });

            var link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);

            link.download = this.$t('DebtorsList') + ".html";

            link.click();

        }, (response) => {

            if (response.status === 0) {

                this.text1 = this.$t('Service-Unavailable')

                this.snackbar = true

                this.load1 = true

                this.progress = false

            } else {

                this.text1 = this.$t('Service-Unavailable')

                this.snackbar = true

                this.load1 = true

                this.progress = false

            }

        })

}

function getListExcel() {

    this.progress = true

    this.grandDebt = 0

    this.dueDebt = 0

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {

        this.Borc.SirketKodu = '0'

    } else {

        this.Borc.SirketKodu = credentials.SirketKodu

    }

    this.Borc.Tarih = this.date

    if (this.a === true) {

        this.Borc.Sira = '0'

    } else if (this.b === true) {

        this.Borc.Sira = '1'

    }

    var params = this.Borc

    this.load1 = false

    this.$http

        .post(auth.API_URL + "api/Report/DebitorListExcel", params, {

            headers: {

                Authorization: "Bearer " + auth.getAuthHeader()

            },

            responseType: "arraybuffer"

        }).then((response) => {

            this.progress = false

            this.load1 = true

            var blob = new Blob([response.data], {

                type: 'application/xlsx'

            });

            var link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);

            link.download =  this.$t('DebtorsList') + ".xlsx";

            link.click();

        }, (response) => {

            if (response.status === 0) {

                this.text1 = this.$t('Service-Unavailable')

                this.snackbar = true

                this.load1 = true

                this.progress = false

            } else {

                this.text1 = this.$t('Service-Unavailable')

                this.snackbar = true

                this.load1 = true

                this.progress = false

            }

        })

}

function beforeMount() {

}

function onChange(v) {

    var c = v.length

    var a = v

    if (c == 8) {

        var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]

        var ay = a[2] + a[3]

        var gun = a[0] + a[1]

        var yil = a[4] + a[5] + a[6] + a[7]

        a = new Date(b)

        if (a instanceof Date && !isNaN(a.valueOf())) {

            //şubatın 29 çekmesin

            if (ay == '02' && yil % 10 != 0 && gun == '29') {

                b = yil + '-' + ay + '-' + '28'

                this.date = b

                this.dateFormatted = '28' + '-' + ay + '-' + yil

                //31 nisan

            } else if (ay == '04' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'

                this.date = b

                this.dateFormatted = '30' + '-' + ay + '-' + yil

                //31 haziran

            } else if (ay == '06' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'

                this.date = b

                this.dateFormatted = '30' + '-' + ay + '-' + yil

                //31 eylül

            } else if (ay == '09' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'

                this.date = b

                this.dateFormatted = '30' + '-' + ay + '-' + yil

                //31 kasım

            } else if (ay == '11' && gun == '31') {

                b = yil + '-' + ay + '-' + '30'

                this.date = b

                this.dateFormatted = '30' + '-' + ay + '-' + yil

            } else {

                this.date = b

            }

        } else {

            this.dateFormatted = null

        }

    } else {

        this.dateFormatted = null

    }

}

function getDateNow() {

    var today = new Date();

    var dd = today.getDate();

    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();

    if (dd < 10) {

        dd = '0' + dd

    }

    if (mm < 10) {

        mm = '0' + mm

    }

    today = yyyy + '-' + mm + '-' + dd

    return today

}

function getDateNow1() {

    var today = new Date();

    var dd = today.getDate();

    var mm = today.getMonth() + 1; //January is 0!

    var yyyy = today.getFullYear();

    if (dd < 10) {

        dd = '0' + dd

    }

    if (mm < 10) {

        mm = '0' + mm

    }

    today = dd + '.' + mm + '.' + yyyy

    return today

}

</script>

<style scoped>

/* @import '../../../assets/css/custom.css'; */

/*
 * Bu blok yalnızca borclulistesi.vue sayfasına özeldir.
 * ReportTable.vue kendi scoped stilini ayrıca taşır.
 */
.borclu-report-table {
    width: 100%;
    margin-top: 8px;
}

.borclu-report-cell {
    width: 100%;
    min-height: 34px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

/*
 * Vue 2 scoped CSS'te child component içindeki kök elemana
 * sayfaya özel mesafe vermek için wrapper üzerinden çalışıyoruz.
 * ReportTable'ın iç stillerini global olarak değiştirmiyoruz.
 */
.borclu-report-table > * {
    width: 100%;
}

</style>
